const common = {
  Loading: "Memuat",
  signUp: "Daftar",
  login: "Gabung",
  logout: "Keluar",
  email: "Email",
  emailFormatErrorTips: "Format email salah",
  emailDifferentTips: "Silakan masukkan email yang sama di kedua bidang.",
  emailRegisteredTips: "Email ini telah terdaftar, silakan pilih yang lain.",
  password: "Kata sandi",
  passwordFormatErrorTips:
    "Kata sandi harus terdiri dari 8-50 karakter dan berisi setidaknya dua kategori di antara yang berikut: angka, huruf, atau karakter khusus.",
  passwordDifferentTips: "Silakan masukkan kata sandi yang sama di kedua bidang.",
  verificationCode: "Kode verifikasi",
  verificationCodeErrorTips: "Kode verifikasi salah",
  confirm: "Konfirmasi",
  cancel: "Batalkan",
  submit: "Kirim",
  confirmEmail: "Konfirmasi email",
  formEmptyErrorTips: "Tidak boleh kosong di sini.",
  country: "Negara / Wilayah",
  birthday: "Tanggal lahir",
  anonymous: "Anonim",
  name: "Nama",
  nameFormatErrorTips: "Nama pengguna harus dalam 50 karakter dan tidak mengandung karakter khusus.",
  okBtn: "Oke",
  serverErrorTips: "Maaf, terjadi kesalahan, harap coba lagi nanti.",
  updateSuccessTips: "Berhasil dimodifikasi",
  authorizationExpiredErrorTips: "Autorisasi telah kedaluwarsa, silakan masuk lagi.",
  requestFrequentlyErrorTips: "Terlalu banyak permintaan yang sama dibuat dalam waktu singkat, harap coba lagi nanti.",
};

export default common;
